import { Directive, OnInit, inject } from '@angular/core';

import { PubSubService } from '../../../core/services/communication/pubsub/pubsub.service';
import { QE_COMPONENT_MISSED_DATA } from '../../../questionEngine/constants/question-engine.constant';
import { QuestionEngineQuizModel } from '../../../questionEngine/models/questionEngineQuiz.model';
import { QuestionEngineService } from '../../../questionEngine/services/question-engine/question-engine.service';

@Directive({ standalone: true })
export class QuestionsInfo implements OnInit {
    qeData: QuestionEngineQuizModel;
    isDesktop = false;
    protected questionEngineService = inject(QuestionEngineService);
    protected pubSubService = inject(PubSubService);

    ngOnInit(): void {
        if (this.questionEngineService.qeData?.baseQuiz) {
            this.qeData = this.questionEngineService.qeData.baseQuiz;
        } else {
            this.pubSubService.publish(this.pubSubService.API.QE_FATAL_ERROR, [QE_COMPONENT_MISSED_DATA]);
        }
    }
}
